export const GROQ_CONFIG = {
  API_KEY: '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',
  API_URL: 'https://api.groq.com/openai/v1/chat/completions',
  MODEL: 'llama-3.3-70b-versatile',
  MAX_TOKENS: 2048,
  TEMPERATURE: 0.7,
};

export const AI_PROMPTS = {
  TEXT_ASSISTANT: 'Você é um assistente especializado exclusivamente em geração e melhoria de textos. Não responda perguntas fora desse escopo. Sempre responda em português brasileiro e preserve o formato HTML quando fornecido. IMPORTANTE: Aplique as melhorias solicitadas diretamente no texto, sem explicar o que foi feito ou adicionar comentários. Retorne apenas o texto melhorado.',
};
